export default function isImage(file) {
  const fileName = file.name || file.path || file.type;
  const suffix = fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase().replace( /image\// , "" );

  if (suffix === 'jpg' || suffix === 'jpeg' || suffix === 'bmp' || suffix === 'png') {
    return true;
  }
  return false;
}
